import { SpentFiatPaymentIntents } from '@sorare/marketplace/src/components/mySorare/TransactionsHistory/SpentFiatPaymentIntents';

const Page = () => {
  return <SpentFiatPaymentIntents />;
};

export default Page;
